import { Expose, Transform } from 'class-transformer';
import { Model } from './model';
import { UserGender } from '../../common';

export class PeakHoursReport extends Model {
  @Expose() onlineTeacher: number;
  @Expose() activeStudent: number;
  @Expose() gender: UserGender;
  @Expose() peakActive: boolean;
  @Expose() peakName: string;
  @Expose() peakPercentage: number = 0;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  date?: Date | null;
}
